var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { styled } from '../../../theme/ThemeHelpers';
var elementResizeDetectorMaker = require("element-resize-detector");
var erdUltraFast = elementResizeDetectorMaker({
    strategy: "scroll" //<- For ultra performance.
});
var ItemInnerElement = styled.div(function (props) { return "\n    display: inline-block;\n    width: 100%;\n    -ms-grid-column ".concat(props.col * 2 - 1, ";\n    ").concat(props.backgroundColor ? "background-color: " + props.backgroundColor : "", ";\n    ").concat(props.rowSpan ? "grid-row-end: span " + props.rowSpan : "", ";\n    ").concat(props.rowSpan ? "-ms-grid-row-span: " + (props.rowSpan * 2 - 1) : "", ";\n    ").concat(props.row ? "-ms-grid-row: " + (props.row * 2 - 1) : "", ";\n"); });
var MasonryItem = /** @class */ (function (_super) {
    __extends(MasonryItem, _super);
    function MasonryItem(props) {
        var _this = _super.call(this, props) || this;
        /**
         *
         */
        _this.h = 0;
        _this.setRef = function (ref) {
            if (ref) {
                erdUltraFast.listenTo({}, ref, function (ele) {
                    var h = ele.getBoundingClientRect().height;
                    if (h !== _this.h) {
                        _this.h = h;
                        //                    console.log(h);
                        var rowSpan = Math.ceil((h + 10) / (_this.props.rowHeight + 10));
                        _this.setState({ rowSpan: rowSpan });
                        _this.props.spanCalculated(_this.props.i, rowSpan);
                    }
                });
            }
        };
        _this.state = {};
        return _this;
    }
    MasonryItem.prototype.render = function () {
        var _this = this;
        var _a;
        return (React.createElement(ItemInnerElement, { rowSpan: this.state.rowSpan, col: this.props.col, row: (_a = this.props.row) !== null && _a !== void 0 ? _a : 1, backgroundColor: this.props.backgroundColor }, React.Children.map(this.props.children, function (m) {
            if (React.isValidElement(m))
                return React.cloneElement(m, { ref: _this.setRef });
            else
                return m;
        })));
    };
    return MasonryItem;
}(React.Component));
export default MasonryItem;
//# sourceMappingURL=MasonryItem.js.map